// extracted by mini-css-extract-plugin
export default {"overLay":"style_overLay__jP+Jr","container":"style_container__SK0ON","close":"style_close__gGMmz","closeModal":"style_closeModal__rgNGe"};